import bem from 'utils/bem';

export const block = bem('legacy-downgrade-modal');
